import { HttpInterceptorFn } from '@angular/common/http';

export const authenticatedInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('token');
  if (token) {
    const excludeUrls = ['users/login'];
    const shouldExclude = excludeUrls.some((url) => req.url.includes(url));
    if (!shouldExclude) {
      const clonedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
      return next(clonedReq);
    }
  }
  return next(req);
};
